module.exports = __webpack_public_path__ + "img/btn.2d722229.png";